import s from "./ProjectInfo.module.css"
import { BsTwitter } from "react-icons/bs"
import { FcLike } from "react-icons/fc"
import { AiFillHeart } from "react-icons/ai"
import { IconContext } from "react-icons";
import { hypeLevel, pageColor } from "../../../helper/helper";
import imgNotFound from "../../../assets/eagleShadow.png"
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LIKE_PROJECT } from "../../../Redux/actions/actions";
import * as React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SimpleDialog from "../../Login/dialogLogin/DialogLogin";

export default function ProjectInfo({setColorFondo,userLikes, setOpenLogin, openLogin,user, likeChanges,setLikedChanges, colorFondo, url, hype, name, twitterFollowers, img, i, id }) {
  let colors = ["beige", "skyblue", "pink", "violet", "orange", "green"];
    const { imageHype, imageClass } = hypeLevel(hype)
    const [hovered, setHovered] = useState(false);
    const dispatch = useDispatch()

    let estilo = pageColor(colorFondo)
    let twitter = twitterFollowers?.replace(" Followers", "")
    twitter = twitter?.replace(" Seguidores", "")
    // let postLiked;
    // likedProjects?.includes(i) ? postLiked = true : postLiked = false
    function handleimgError({ currentTarget }) {
        currentTarget.onerror = null;
        currentTarget.src = imgNotFound
    }
   
    const like = (projectId, likeChanges) => {
        if(!user.ok){
            setOpenLogin(true)
            return
        }
        if(!likeChanges) setLikedChanges(true)
        dispatch(LIKE_PROJECT(projectId))
    }

    const changeColor = () => {
        let position = colors.findIndex(color=> colorFondo === color)
        position === 5 ? setColorFondo(colors[0]) : setColorFondo(colors[++position]);
        console.log("estoyt aca")
      };

    const handleMouseEnter = () => setHovered(true);
    const handleMouseLeave = () => setHovered(false);

    return (
        <div className={s.row}>
            <div className={s.number}><div className={s.indice}>{i + 1}</div></div>
            <div className={s.imgContainer}><img width={"100"} height={"100"} src={img === "nothing" ? imgNotFound : img} onError={(e) => handleimgError(e)} alt={name} /></div>
            <div className={s.name}>{name}</div>
            <IconContext.Provider value={{ className: s.icon, size: "1em" }}>
                <div className={s.logoContainer}>
                    <div className={s.tweetdiv} onClick={() => window.open(url)}><BsTwitter className={s.twitter} /><span>{twitter}</span></div>
                </div>
            </IconContext.Provider>
            <div className={s.imgContainer} onClick={()=>changeColor()}><img style={estilo} className={s[imageClass]} width={"100"} height={"100"} src={imageHype} alt="hype" /></div>
            <div className={s.logoContainer}>
                <div className={s.likeDiv} onClick={() => like(id, likeChanges)}><span>{userLikes?.length}</span><AiFillHeart onMouseEnter={() => handleMouseEnter()}
                    onMouseLeave={() => handleMouseLeave()} color={userLikes?.includes(user?.id) ? "red" : estilo?.backgroundColor} className={s.like} /></div>
            </div>
            {/* <div><span>{hype}</span></div> */}
        </div>

    )
}